import { getRequest } from "../../globalhelper/helper";
import store from "../../store";
import { navigateToModule } from "../Common/commonActions";
import { SET_MODULES } from "./interactionsActionTypes";

const setModules = (modules) => {
  return (dispatch) => {
    dispatch({
      type: SET_MODULES,
      payload: modules,
    });
    if (modules.length === 1) {
      dispatch(navigateToModule(modules[0]));
    }
  };
};

export function loadModules() {
  return (dispatch) => {
    return getModules().then((data) => {
      if (data.type === "success") {
        dispatch(setModules(data.res.data));
      }
    });
  };
}

const getModules = () => {
  const STATE = store.getState();
  return getRequest(
    "api/module/modules?tenant_id=" + STATE.login.userData.USR_Tenant
  ).then((data) => data);
};
